<div class="amp-dialog">
  <p class="amp-dialog-title">{{title}}</p>
  <p class="amp-dialog-subtitle" [innerHTML]="subtitle"></p>

  <div class="amp-dialog-actions">
    <button type="button" class="amp-btn-light" (click)="cancel()">{{cancelButton}}</button>
    <button class="amp-btn-danger" (click)="confirm()">{{confirmButton}}</button>
  </div>
</div>